import type { OrderDetail } from "./medusa"

/**
 * The three money-and-stock tools on a site order's page (Refund, Return, Cancel): always shown at
 * the top, each with the reason when it cannot be used. The backend refuses the same cases.
 */
export type Tool = "refund" | "return" | "cancel"
export type ToolWhy = "all_refunded" | "cash_not_collected" | "nothing_taken" | "canceled" | "not_left" | "all_back" | "has_left"
export type ToolState = { ok: true } | { ok: false; why: ToolWhy }

type ToolOrder = Pick<OrderDetail, "status" | "can_cancel" | "items"> & { payment: Pick<OrderDetail["payment"], "kind" | "collected" | "refunded" | "refundable"> }

export function toolStates(order: ToolOrder): Record<Tool, ToolState> {
  const canceled = order.status === "canceled"
  const refund: ToolState =
    order.payment.refundable > 0
      ? { ok: true }
      : { ok: false, why: order.payment.refunded > 0 ? "all_refunded" : order.payment.kind === "cash" && !order.payment.collected ? "cash_not_collected" : "nothing_taken" }
  const left = order.items.some((item) => item.fulfilled > 0)
  const back: ToolState = canceled
    ? { ok: false, why: "canceled" }
    : order.items.some((item) => (item.returnable ?? 0) > 0)
      ? { ok: true }
      : { ok: false, why: left ? "all_back" : "not_left" }
  const cancel: ToolState = canceled ? { ok: false, why: "canceled" } : order.can_cancel ? { ok: true } : { ok: false, why: "has_left" }
  return { refund, return: back, cancel }
}
